<template>
  <div class="profile">
      Hello!
    <!-- Check that the SDK client is not currently loading before accessing is methods -->
  </div>
</template>

<script>
export default {
    name: 'profile',
    components: {
    }
}
</script>
